<div class="root-container d-flex flex-column flex-lg-row">
  <sidebar-menu *ngIf="(isAuthenticated$ | async) && (hasUserRights$ | async)"
    class="d-none d-lg-block"
    [isAdmin]="isAdmin"
    [username]="username"
    [menuItems]="menuItems"
    [showAppVersion]="showAppVersion"
    (userNavOptionSelect)="onUserNavOptionSelect($event)"
  ></sidebar-menu>
  
  <div class="layout-body d-flex flex-column flex-grow-1">
    <banner-notification></banner-notification>
    <header-menu *ngIf="isAuthenticated$ | async"
      [hasUserRights]="hasUserRights$ | async"
      [isAdmin]="isAdmin"
      [username]="username"
      [menuItems]="menuItems"
      [showAppVersion]="showAppVersion"
      (userNavOptionSelect)="onUserNavOptionSelect($event)"
    ></header-menu>
  
    <div class="layout-content flex-grow-1 container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<loader></loader>

<style-loader *ngIf="(isAuthenticated$ | async) && (hasUserRights$ | async)"></style-loader>